import React from 'react';
import FindApplication from './components/FindApplication';
import { MenuAfterShowNewExportImport } from '../../utils/formatters';
import Empty from '../../components/base/Empty';
import CarrierRegistryPage from './components/CarrierRegistryPage';
import VehicleRegistryPage from './components/VehicleRegistryPage';
import SZLTRegistryPage from './components/SZLTRegistryPage';
import RegistryHistoryPage from './components/RegistryHistoryPage';
import RegistryExportPage from './components/RegistryExportPage';
import RegistrySmevCheckPage from './components/RegistrySmevCheckPage';
import PresetLink from '../Application/components/PresetLink';

const routes = [
  {
    path: '/region-registry-carrier',
    name: 'menu.region.registry',
    icon: 'region-registry',
    customIcon: true,
    loginRequired: true,
    forAll: true,
    component: () => null,
    weight: 2,
    permission: [],
    children: [
      {
        path: '/region-registry/find',
        name: 'menu.application',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        onlyComponent: true,
        forAll: true,
        component: Empty,
        MenuComponent: FindApplication,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/region-registry-carrier',
        name: 'menu.region.registry.carrier',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: CarrierRegistryPage,
        afterContent: <MenuAfterShowNewExportImport path="/region-registry-carrier" />,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/region-registry/passenger-taxi',
        name: 'menu.region.registry.passenger.taxi',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: VehicleRegistryPage,
        afterContent: <MenuAfterShowNewExportImport path="/region-registry/passenger-taxi" />,
        weight: 2,
        permission: [],
        children: [
          {
            path: '/region-registry/passenger-taxi?block_180_days=true',
            name: 'menu.region.registry.passenger.taxi.block_180_days',
            icon: 'application',
            customIcon: true,
            loginRequired: true,
            onlyComponent: true,
            forAll: true,
            component: () => {},
            MenuComponent: PresetLink,
            weight: 2,
            permission: [],
            children: [],
          },
        ],
      },
      {
        path: '/region-registry/szlt',
        name: 'menu.region.registry.szlt',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: SZLTRegistryPage,
        afterContent: <MenuAfterShowNewExportImport path="/region-registry/szlt" />,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/region-registry/export',
        name: 'menu.region.registry.export',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: RegistryExportPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/region-registry/smev-check',
        name: 'menu.region.registry.smev.check',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: RegistrySmevCheckPage,
        weight: 2,
        permission: [],
        children: [],
      },
      {
        path: '/region-registry/history',
        name: 'menu.region.registry.history',
        icon: 'application',
        customIcon: true,
        loginRequired: true,
        forAll: true,
        component: RegistryHistoryPage,
        weight: 2,
        permission: [],
        children: [],
      },
    ],
  },
];

export default routes;
